import { Loader2, CheckCircle2, XCircle } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { PublishStatus } from '@/lib/api/types'

interface PublishStatusBadgeProps {
  publishStatus: PublishStatus | null
  publishError: string | null
}

export function PublishStatusBadge({ publishStatus, publishError }: PublishStatusBadgeProps) {
  if (!publishStatus) return null

  const config: Record<PublishStatus, { className: string; icon: React.ReactNode; label: string }> = {
    pending: {
      className: 'bg-amber-100 text-amber-700',
      icon: <Loader2 className="w-3 h-3 animate-spin" />,
      label: 'Publishing...',
    },
    processing: {
      className: 'bg-amber-100 text-amber-700',
      icon: <Loader2 className="w-3 h-3 animate-spin" />,
      label: 'Publishing...',
    },
    succeeded: {
      className: 'bg-emerald-100 text-emerald-700',
      icon: <CheckCircle2 className="w-3 h-3" />,
      label: 'Published to Webflow',
    },
    failed: {
      className: 'bg-destructive/10 text-destructive',
      icon: <XCircle className="w-3 h-3" />,
      label: 'Publish Failed',
    },
  }

  const { className, icon, label } = config[publishStatus]

  return (
    <span className="inline-flex items-center gap-2">
      <Badge variant="secondary" className={`inline-flex items-center gap-1 ${className}`}>
        {icon}
        {label}
      </Badge>
      {publishStatus === 'failed' && publishError && (
        <span className="text-xs text-muted-foreground">&mdash; {publishError}</span>
      )}
    </span>
  )
}
